exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-editor-container[data-v-4dfc1336] {\n  background-color: #e3e3e3;\n  min-height: 100vh;\n  padding: 0.260417rem 0.3125rem 0;\n}\n@keyframes happy-data-v-4dfc1336 {\nto {\n    color: #3498db;\n    transform: scale(1) rotateZ(0);\n}\n50% {\n    color: #f1c40f;\n    transform: scale(0.5) rotateZ(180);\n}\nfrom {\n    color: #ff7675;\n    transform: scale(1) rotateZ(360);\n}\n}", ""]);

// exports
